<!------------------------------------------------------------------------------
- Copyright (c) 2019. BMW Group. All rights reserved.
----------------------------------------------------------------------------->

<p><strong>{{name}}</strong></p>
<br/>
<p>Associated ship to parties:</p>
@for (item of descriptionShipToParties(description); track item) {
  <p>{{item}}</p>
}
<br/>
<p>Model codes expertise:</p>
<p>{{descriptionModelCodes(description)}}</p>
